import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { mergeThemeOverride as h, ChakraProvider as s } from "@chakra-ui/react";
import { GlobalStyles as n } from "./GlobalStyles.es.js";
import { a as p } from "../theme-558c1b07.js";
import { ThemeFont as a } from "../fonts/fonts.es.js";
const x = ({
  children: r,
  fonts: o = ["400", "500", "mono-400"],
  theme: m = {}
}) => {
  const t = h(p, m);
  return /* @__PURE__ */ i(s, { theme: t, children: [
    /* @__PURE__ */ e(n, {}),
    /* @__PURE__ */ e(a, { fonts: o }),
    r
  ] });
};
export {
  x as ThemeProvider
};
//# sourceMappingURL=ThemeProvider.es.js.map
